var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._t("title-icon"),_vm._t("title-name")],2),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }